import { PickupCorporateScheduleConfigRepositoryInterface } from "@/data/persistences/repositories/contracts/PickupCorporateScheduleConfigRepositoryInterface";
import { PickupCorporateScheduleConfig } from "@/domain/entities/PickupCorporateScheduleConfig";
import { injectable } from "tsyringe";

@injectable()
export class PickupCorporateScheduleConfigPresenter {
  constructor(
    private repository: PickupCorporateScheduleConfigRepositoryInterface
  ) {}

  public loadConfig(clientId?: number): Promise<PickupCorporateScheduleConfig> {
    return this.repository.loadConfig(clientId);
  }

  public saveConfig(config: PickupCorporateScheduleConfig): Promise<boolean> {
    return this.repository.saveConfig(config);
  }
}
